var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marquee-container"},[_c('div',{staticClass:"marquee-content"},[_c('span',{staticClass:"marquee-text"},[_vm._v(_vm._s(_vm.message))]),_c('span',{staticClass:"marquee-text"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }